<template>
    <generic-page>
        <div class="p-3">
            <div v-if="loading">
                <generic-loading />
            </div>
            <div v-else-if="creatorVideos && creatorVideos.length">
                <div class="video-grid">
                    <div
                        v-for="{ creatorVideo } in creatorVideos"
                        :key="creatorVideo.id"
                        @click="
                            $router.push({
                                name: 'creatorVideoIndex',
                                params: { slug: creatorVideo.slug },
                            })
                        "
                    >
                        <creator-video-avatar :creatorVideo="creatorVideo" />
                    </div>
                </div>
            </div>
        </div>

        <generic-pagination
            @next="next"
            @previous="previous"
            :hasMorePages="hasMorePages"
            :page="page"
        />
    </generic-page>
</template>

<style scoped>
.video-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
}
</style>

<script>
import { mapState } from "vuex";

import GenericPagination from "@/components/utility/GenericPagination";
import CreatorVideoAvatar from "@/components/creatorVideo/CreatorVideoAvatar";

export default {
    data() {
        return {
            page: 1,
            hasMorePages: false,
            creatorVideos: null,
            loading: false,
        };
    },
    created() {
        this.refresh();
    },
    computed: {
        ...mapState("profile", ["profile"]),
    },
    methods: {
        next() {
            this.page++;
            this.refresh();
        },
        previous() {
            this.page--;
            this.refresh();
        },
        refresh() {
            this.loading = true;

            this.api
                .post("/creatorVideo/customerIndex", {
                    page: this.page,
                    view: "user",
                    userId: this.profile.id,
                })
                .then((response) => {
                    this.creatorVideos = response?.data?.creatorVideos;
                    this.hasMorePages = response?.data?.hasMorePages;
                })
                .catch(() => {})
                .then(() => {
                    this.loading = false;
                });
        },
    },
    components: {
        GenericPagination,
        CreatorVideoAvatar,
    },
};
</script>
